/**
 * Support context.
 */
import React from 'react'
import config from 'react-global-configuration'
import { apiFetchWithAccessToken } from './lib/api-fetch'

export const SupportContext = React.createContext(null)
export const SupportConsumer = SupportContext.Consumer

interface SupportStoreProps {
  children: any
}

export interface SupportContext {
  requests: any[]
  request: any
  message: any
}

export class SupportStore extends React.Component<SupportStoreProps> {
  state = {
    supportContext: {
      requests: [],
      request: null,
      message: null,
    }
  }

  async componentDidMount() {
  }

  fetchSupportRequests = async () => {
    const response = await apiFetchWithAccessToken('GET', config.get('SUPPORT_API_URL') + '/requests')
    this.setState({
      supportContext: { ...this.state.supportContext,
        requests: response,
      }
    })
  }

  updateSupportRequest = async (requestId: string, request: any) => {
    const response = await apiFetchWithAccessToken('PUT', config.get('SUPPORT_API_URL') + '/requests/' + requestId, request)
    this.setState({
      supportContext: { ...this.state.supportContext,
        request: response,
      }
    })
  }

  deleteSupportRequest = async (requestId: string) => {
    await apiFetchWithAccessToken('DELETE', config.get('SUPPORT_API_URL') + '/requests/' + requestId)
  }

  updateSupportMessage = async (requestId: string, messageId: string, message: any) => {
    const response = await apiFetchWithAccessToken('PUT', config.get('SUPPORT_API_URL') + '/requests/' + requestId + '/messages/' + messageId, message)
    this.setState({
      supportContext: { ...this.state.supportContext,
        message: response,
      }
    })
  }

  deleteSupportMessage = async (requestId: string, messageId: string) => {
    await apiFetchWithAccessToken('DELETE', config.get('SUPPORT_API_URL') + '/requests/' + requestId + '/messages/' + messageId)
  }

  render() {
    return (
      <SupportContext.Provider value={{ ...this.state.supportContext,
        fetchSupportRequests: this.fetchSupportRequests,
        updateSupportRequest: this.updateSupportRequest,
        deleteSupportRequest: this.deleteSupportRequest,
        updateSupportMessage: this.updateSupportMessage,
        deleteSupportMessage: this.deleteSupportMessage,
      }}>
        {this.props.children}
      </SupportContext.Provider>
    )
  }
}

export function withSupportContext(Comp: any) {
  return (props: any) => (
    <SupportContext.Consumer>
      {(supportContext: SupportContext) => <Comp {...props} supportContext={{...supportContext}}/>}
    </SupportContext.Consumer>
  )
}
